import React from "react";
import { classnames, Button, Icon } from "@culturehq/components";

import { useDelayedCallback } from "app/hooks";
import { Trans } from "app/utils";

const SelectButton = ({ story, onClick }) => {
  const [selected, onSelect] = useDelayedCallback(2000, () => onClick(story));

  if (story.selected) {
    return (
      <span className={classnames("approve-story", { "approve-story-anim": selected })}>
        <Button primary onClick={onSelect} inverted>
          <Icon icon="checkmark" /><Trans>Selected</Trans>
        </Button>
        {selected && (
          <>
            <span className="approve-story--circle" />
            <span className="approve-story--check-white">
              <span className="legend">
                <Icon icon="ios-plus" /><Trans>Select Story</Trans>
              </span>
            </span>
          </>
        )}
      </span>
    );
  }

  return (
    <span className={classnames("approve-story", { "approve-story-anim": selected })}>
      <Button primary onClick={onSelect}>
        <Icon icon="ios-plus" /><Trans>Select Story</Trans>
      </Button>
    </span>
  );
};

export default SelectButton;
